export default __webpack_public_path__ + "static/media/callendar.824e54ee.svg";